import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class RecoverPasswordRequest {
  @jsonMember readonly email!: string;

  constructor(email: string) {
    this.email = email;
  }
}
